import styled from 'styled-components'

const Card = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 360px;
  min-height: 520px;
  padding-top: 30px;
  padding-bottom: 17px;
  padding-left: 20px;
  padding-right: 20px;
  background: white;
  border-radius: 10px;
`

export const CardOverlay = styled(Card)`
  position: fixed;
  z-index: 5000;
`

export default Card
